import React from 'react';

import { SimpleGrid } from '../../component-primitives/simple-grid';
import { Progress } from '../progress';
import { MultiStepProgressBarProps } from './types';

export const MultiStepProgressBar = ({
  progresses,
  size = 'md',
}: MultiStepProgressBarProps) => {
  const progressesList = progresses && progresses?.length ? progresses : [0];
  return (
    <SimpleGrid columns={progressesList.length} spacing={1.5}>
      {progressesList.map((progress, index) => (
        <Progress key={index} value={progress} size={size} />
      ))}
    </SimpleGrid>
  );
};
